const IMGIX_HOST = 'images.flashpack.com';
const IMGIX_BASE_PATH = '/wp-content/uploads';

export const imgixUrl = (src: string): string => {
  try {
    const { pathname } = new URL(src);
    const imgixSrc = `https://${IMGIX_HOST}${pathname.replace(IMGIX_BASE_PATH, '')}`;
    return imgixSrc;
  } catch (error) {
    console.warn('Failed to parse image URL', src, error);
    return '';
  }
};
